(function () {
  var toggleFrameOnly = document.getElementById("page-length-toggle-frame-only");
  var content = document.getElementById("page-length-content");
  var visibilityStatus = document.getElementById("page-length-visibility-status");
  var tocSection = document.getElementById("section-toc");
  var breadcrumbSection = document.getElementById("breadcrumb");

  if (!toggleFrameOnly || !content || !visibilityStatus) {
    return;
  }

  function updateState() {
    var frameOnlyEnabled = !!toggleFrameOnly.checked;

    content.hidden = frameOnlyEnabled;

    if (tocSection) {
      tocSection.hidden = frameOnlyEnabled;
    }

    if (breadcrumbSection) {
      breadcrumbSection.hidden = frameOnlyEnabled;
    }

    visibilityStatus.innerHTML = frameOnlyEnabled
      ? "<strong>Visibility:</strong> Frame only."
      : "<strong>Visibility:</strong> Full page content.";

    document.dispatchEvent(new CustomEvent("refreshFrame"));
    document.dispatchEvent(new CustomEvent("refreshStickyLayout"));
  }

  toggleFrameOnly.addEventListener("change", updateState);
  updateState();
})();
